/* eslint-disable react/no-multi-comp */
const React = require("react");
const Link = require("../../core/view/Link");

const getPrivacyContent = function(styles) {
	return (
		<div>
			<h2 className={styles.header}>Beast Academy Privacy Policy</h2>
			<p>
				{`Beast Academy, operated by AoPS Incorporated, is dedicated to sharing our love of
				math and puzzles to inspire the next generation of Math Beasts! As an educational
				service provider used by schools, children, and families, Beast Academy takes the
				privacy of our users very seriously. This policy has been adopted to address the
				collection and use of information from all Beast Academy websites, including Beast
				Academy Online. We collect and use information from users in order to efficiently
				and effectively provide our services. We will never sell or rent users’ personal
				information to third-parties. Please do not hesitate to contact us if you have any
				questions about our privacy practices.`}
			</p>
			<h2 className={styles.header}>COPPA Compliance</h2>
			<p>
				{`Children under the age of 13 (“children” or “child”) may access BeastAcademy.com.
				Therefore, Beast Academy’s information practices comply with the federal Children's
				Online Privacy Protection Act (“COPPA”). COPPA requires that we inform you of our
				practices with regards to our collection, use, or disclosure of personal information
				from children under the age of 13, and to obtain verifiable parental consent prior
				to collecting, using, or disclosing any such information.`}
			</p>
			<p>
				{`If we discover we have collected information from a child in a manner inconsistent
				with COPPA’s requirements, we will either seek the parent’s consent for that
				collection or delete the information. We won’t require a child to disclose more
				information than is reasonably necessary to participate in an activity.`}
			</p>
			<p>
				<span className={styles.paragraphStart}>
					Verifiable Parental Consent:
				</span>
				{`In order for a child to access certain Beast Academy services, either (a) a parent
				or legal guardian (“Parent”) must provide verifiable parental consent; or (b) a
				teacher or other authorized school administrator must provide consent on behalf of
				the Parent.`}
			</p>
			<p>
				{`Beast Academy generally obtains verifiable parental consent prior to collecting,
				using, or disclosing any personal information from children. There are limited
				instances where we may collect information without parental consent in compliance
				with COPPA, including:`}
			</p>
			<ol type="i" className={styles.list}>
				<li>
					{`To protect the security or integrity of our sites, applications, and other
					technology;`}
				</li>
				<li>
					{`A username may be selected by the child; however, this username is only used
					for signing in and cannot be used to contact the child unless and until we
					receive verifiable parental consent; and`}
				</li>
				<li>
					{`We may collect contact information in order to respond to a specific request
					from a student on a one-time basis.`}
				</li>
			</ol>
			<p>
				<span className={styles.paragraphStart}>
					Participation in Beast Academy:
				</span>
				{`Some Beast Academy services do not collect personal information from students and
				are designed to prevent students from accidentally providing personal information to
				us. These services are available without requiring verifiable parental consent.`}
			</p>
			<p>
				<span className={styles.header}>
					What Information Does Beast Academy Collect?
				</span>
			</p>
			<p>
				<span className={styles.subheader}>Information Users Provide</span>
			</p>
			<p>
				{`Beast Academy collects different types of information from Students; from Parents;
				and from teachers, school administrators, and other educators (“Educators”).`}
			</p>
			<ul className={styles.largeList + " " + styles.list}>
				<li>
					<span className={styles.paragraphStart}>Contact Information:</span>
					{`Parents and Educators may choose to provide us with their name, email address,
					and/or phone number while interacting with our sites and services. For instance,
					you may provide contact information in order to sign up for an account, sign up
					for email updates, complete a purchase, or submit a contact form or support
					request. Students are not asked for their own contact information. If you are a
					Parent or Educator, we may use your name, email address, and phone number for
					marketing purposes, but only if you give your express permission to do so, and
					such permission may be withdrawn at any time by contacting us or through the
					unsubscribe link in an email. We will share that information with a third party
					for the purposes of sending these emails, and texts. We will also share that
					information with third party social media platforms you may use to share
					updates, information about our services, and marketing information with you on
					those platforms. We will not otherwise share your contact information with third
					parties except when required by law. We will never sell or rent your contact
					information to third parties. Even if you opt out of marketing communication,
					however, we reserve the right to send you transactional messages, including
					email and other communications to provide account related information, disclose
					maintenance, transaction-related matters (e.g., order confirmation, shipping
					information, account status information, etc.) and other service-related
					issues.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						Customized Username and Avatar:
					</span>
					{`A username used to uniquely identify each Student may be created during
					registration. This username may be disclosed on our website, for example in
					leaderboards or lists of contest winners.  The username a Student selects is
					used as an onscreen name to identify them; it is strongly recommended that it
					not be their real name, but a pseudonym.  Users may also be able to create
					customizable avatars that will be accessible to other users. We strongly
					recommend that users do not include any personal information (e.g., their
					likeness, real name) in their customizable avatar.  Parents and Educators can
					adjust Privacy Settings at any time to remove or limit the visibility of the
					Student's avatar and username.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						Student Data Provided by a Parent:
					</span>
					{`Parents may provide information about their children to register them for
					Beast Academy. This information may be shared with any other Parents or
					Educators who are linked to a Student’s account. A Student’s real name will
					never be made publicly available on our website by us.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>School Registration:</span>
					{`School and district administrators or their designees (hereinafter “School
					Administrators”) can register with Beast Academy to use Beast Academy’s products
					and services as part of their instruction to students.  A School Administrator
					may create accounts for other Educators in order to grant access to student
					information to authorized individuals. In order to register as a school, we
					collect the School Administrator’s name, school name, school address, contact
					phone number, email address, and school website URL. We ask for this information
					to verify that the School Administrator works for a legitimate educational
					institution or homeschool. We may request other evidence of school affiliation,
					as necessary, to determine your eligibility to create a school account.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						Student Data Provided by an Educator:
					</span>
					{`Educators may upload certain data about Students as part of integrating Beast
					Academy into school activities, or connect Beast Academy to a rostering system
					or LMS to receive data. Beast Academy serves as a school official under the
					Family Educational Rights and Privacy Act, and is able to receive student data
					as we have legitimate educational interest in the information – it’s needed to
					provide our academic services. Such data may include student names, classroom
					rosters, academic data, and more. Educators may enroll students on behalf of
					their parents into Beast Academy Online. Where a student is under the age of 13,
					Educators agree that they, or their school, are acting as the students’ parents’
					agent in providing consent for the online collection of students’ personal
					information within the school context. Please note: we will only use children's
					information we collect with the school's consent for educational purposes.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						Student Performance Data:
					</span>
					{`As Students use Beast Academy, their progress and performance (“Student
					Performance Data”) may be stored.  We use this data in order to fulfill the
					educational purposes of the product and to analyze and improve Beast Academy.
					The Parent or Educators linked to a Student’s account can see reports on that
					Student’s Student Performance Data. Limited Student Performance Data may be
					publicly available through the Leaderboard, but Parents and Educators can adjust
					Privacy Settings at any time to remove or limit the disclosure of Student
					Performance Data.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						Inviting Others and Linking Accounts:
					</span>
					{`A Parent or Educator may invite other Parents or Educators to be linked to a
					student or class. You may initiate the link by providing us with the email
					address of the person you want to link or by providing a code from us to the
					person you want to invite. Any personal information collected for this purpose
					will be handled in accordance with this privacy policy.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Communication Tools:</span>
					{`Beast Academy may offer communication tools through which students may be able
					to post messages to our staff, their Parents, or their Educators. Parents and
					Educators may be able to message their Students and AoPS staff, as well as other
					Parents and Educators linked to their Students’ accounts. Parents will be able
					to review any communication with or by their children on the Beast Academy
					platform (with the exception of AoPS and AoPS-related communications noted
					below). Educators may be able to send messages to their Students or their
					Students’ parents through these tools. Additionally, a Parent or Educator may
					choose to provide contact information (e.g., email, phone, text) to obtain
					regular updates from us.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						Integration with AoPS and AoPS Academy websites:
					</span>
					{`Portions of the Beast Academy website may be integrated into classes offered
					by Art of Problem Solving via the AoPS (www.artofproblemsolving.com) and AoPS
					Academy (www.aopsacademy.org) websites. Students participating in those classes
					may be able to post through the Beast Academy website to message boards on the
					www.artofproblemsolving.com and www.aopsacademy.org websites. The Privacy Policy
					for www.artofproblemsolving.com can be found `}
					<Link
						to="//artofproblemsolving.com/company/privacy"
						isExternal={true}
						isNewTab={true}
						className={styles.link}
					>
						here
					</Link>
					{`, and the Privacy Policy for www.aopsacademy.org can be found `}
					<Link
						to="//aopsacademy.org/legal/privacy"
						isExternal={true}
						isNewTab={true}
						className={styles.link}
					>
						here
					</Link>
					{`. This external message board integration does not apply to Students unless
					they are enrolled in AoPS Academy classes or in the Art of Problem Solving
					Online School.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Payment Information:</span>
					{`Beast Academy offers numerous products and services for purchase online,
					including engaging math workbooks.  Some of our products are purchased through a
					monthly subscription service. We collect certain information from a customer who
					is purchasing a product and/or service using our online ordering system. Such
					information may include name, shipping address, billing address, credit card
					information, other information related to other forms of payment (e.g., Paypal),
					email address, and phone number. This information is used to process purchases
					and to contact you if there is an issue with your purchase. We will share this
					information with our credit card payment processor. Additionally, your name,
					shipping address, email address, and/or phone number may be shared with the
					United States Postal Service or other private carrier, for the purpose of
					delivering any purchased goods to your shipping address. We will store all of
					this information on our secure server, except for your credit card information,
					which is only retained until your payment has been processed and is not stored
					thereafter; however, this information may be retained by our credit card
					processor in order to process additional transactions. You will be notified via
					email of each transaction. We will not use this information for any purpose
					other than to process your purchase, and will not share this information with
					any other third party, except as described above, or as may be required by
					law.`}
				</li>
			</ul>
			<p>
				<span className={styles.subheader}>
					Information Collected Automatically
				</span>
			</p>
			<p>
				<span className={styles.paragraphStart}>Device and Use Data:</span>
				{`Like most websites, we automatically collect certain technical information from
				your browser or device when you visit our website. We collect technical information
				such as your device’s IP address, socket id, web browser version, and operating
				system. We collect information on which pages users visit and how you use the
				website. We use this information to optimize your online experience for your device,
				to diagnose any problems with our server, to improve the performance of our website,
				and to provide support for our internal operations.`}
			</p>
			<p>
				<span className={styles.paragraphStart}>Web Beacons:</span>
				{`A "web beacon" is a small image that appears in emails we send to users in order
				to track whether an email is opened. We use this information in order to analyze
				trends, improve the content of our emails, and update our mailing lists.`}
			</p>
			<p>
				<span className={styles.paragraphStart}>Cookies:</span>
				{`A "cookie" is a small piece of data placed on your computer by us. Within your web
				browser, cookies placed by our website can only be accessed by our website. The data
				collected using cookies typically includes information such as your IP address or
				mobile identifier, the type of computer operating system, the web browser, the
				frequency with which the user visits various parts of our sites or applications, and
				information regarding the online or mobile service provider. We use cookies to
				maintain session and preference information and to improve the use of the website.
				You may set your web browser to decline our cookies; however this will render large
				portions of our website unusable.`}
			</p>
			<p>
				{`We also allow cookies to be placed on your computer by a third party for the
				purpose of website analytics.  This allows a third party to collect data about your
				use of our website; however, no personally identifiable information is collected.
				Our third party service providers may set cookies on a user’s web browser and/or
				obtain information about the fact that a web browser visited the Beast Academy
				website from a certain IP address. Third parties cannot collect any other personally
				identifiable information from Beast Academy’s website unless you provide it to them
				directly.`}
			</p>
			<p>
				{`We generally use the data collected from third-party cookies in the following
				ways:`}
			</p>
			<ul className={styles.list}>
				<li>
					{`to report, in aggregate, how our visitors find and use our website;`}
				</li>
				<li>{`to understand overall visitor behavior; and`}</li>
				<li>{`to inform how we update and improve our website.`}</li>
			</ul>
			<p>
				{`For any questions about how we or any third-party uses your data, please do not
				hesitate to contact us.`}
			</p>
			<p>
				<span className={styles.header}>
					How Else May Beast Academy Use Collected Information?
				</span>
			</p>
			<p>
				{`Consistent with the information collection practices outlined above, we share
				information with service providers if necessary for them to perform a business,
				professional, or technology support function for us (e.g., billing support,
				analytics, hosting, marketing, and similar services). All service providers are
				required to maintain the confidentiality of such information in accordance with
				applicable law.  This includes Beast Academy affiliates (e.g., AoPS Academy), with
				whom we collaborate to provide services.  We may combine the different types of
				information we collect in order to improve the site, perform analysis, or offer
				support. Our practices conform with the law and the consent provided on behalf of
				students and children. We may also disclose a user’s personal information if
				permitted or required by law, for example, in response to a court order or a
				subpoena.`}
			</p>
			<p>
				{`In the event Beast Academy is involved in a merger, acquisition, sale of business
				assets involving customer information, or similar transaction, your information may
				be transferred or shared as part of the transaction. We will work to require the
				recipient to protect all personal information collected from Beast Academy users in
				accordance with the terms of this Privacy Policy.`}
			</p>
			<p>
				<span className={styles.header}>Security</span>
			</p>
			<p>
				{`The security and confidentiality of your personal information is very important to
				us. We implement commercially reasonable physical, technical, and administrative
				security methods to protect the information we collect from users. While the
				security of your personal information is of the utmost importance to us, we cannot
				absolutely guarantee the security of any information you choose to disclose.`}
			</p>
			<p>
				{`We use the secure HTTPS protocol for all page loads. User data
				is transmitted over a Secure Socket Layer (SSL) connection.
				Passwords are encrypted in transit using Transport Layer
				Security (TLS) and are cryptographically hashed at rest. We
				maintain internal data management policies and procedures,
				system monitoring, and incident response plans.`}
			</p>
			<p>
				<span className={styles.header}>Data Retention</span>
			</p>
			<p>
				{`The following describes Beast Academy’s data retention policies for categories of personal information that are collected:`}
			</p>
			<table className={styles.privacyTable}>
				<thead>
					<tr className={styles.tableHeader}>
						<td>Category</td>
						<td>Purpose</td>
						<td>Third Parties Shared</td>
						<td>Retention Period</td>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{`Identifiers`}</td>
						<td>
							(a) Performance of a contract
							<br /> (b) Necessary for our legitimate interests
							<br /> (c) Necessary to comply with a legal obligation
						</td>
						<td>
							(a) Billing, marketing, hosting, analytics and similar service
							providers
							<br />
							(b) Subsidiaries and affiliates
						</td>
						<td>
							{`We will retain information about you for so long as we have a legal or business purpose for it or a legal requirement to maintain it.  Once we no longer have a legal or business purpose for the information and no legal requirement to maintain the information, we will promptly purge the information.
						`}
						</td>
					</tr>
					<tr>
						<td>{`Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e))`}</td>
						<td>
							(a) Performance of a contract
							<br />
							(b) Necessary for our legitimate interests
							<br />
							(c) Necessary to comply with a legal obligation
						</td>
						<td>
							(a) Billing, marketing, hosting, analytics and similar service
							providers
							<br />
							(b) Subsidiaries and affiliates
						</td>
						<td>{`We will retain information about you for so long as we have a legal or business purpose for it or a legal requirement to maintain it.  Once we no longer have a legal or business purpose for the information and no legal requirement to maintain the information, we will promptly purge the information.`}</td>
					</tr>
					<tr>
						<td>{`Commercial information`}</td>
						<td>
							(a) Performance of a contract
							<br />
							(b) Necessary for our legitimate interests
							<br />
							(c) Necessary to comply with a legal obligation
						</td>
						<td>
							(a) Billing, marketing, hosting, analytics and similar service
							providers
							<br />
							(b) Subsidiaries and affiliates
						</td>
						<td>
							{`We will retain information about you for so long as we have a legal or business purpose for it or a legal requirement to maintain it.  Once we no longer have a legal or business purpose for the information and no legal requirement to maintain the information, we will promptly purge the information.`}
						</td>
					</tr>
					<tr>
						<td>{`Internet or other similar network activity`}</td>
						<td>{`(a) Necessary for our legitimate interests`}</td>
						<td>
							(a) Hosting, marketing, analytics, security and similar service
							providers
							<br />
							(b) Subsidiaries and affiliates
						</td>
						<td>
							{`We will retain information about you for so long as we have a legal or business purpose for it or a legal requirement to maintain it.  Once we no longer have a legal or business purpose for the information and no legal requirement to maintain the information, we will promptly purge the information.`}
						</td>
					</tr>
					<tr>
						<td>{`Geolocation data`}</td>
						<td>
							(a) Performance of a contract
							<br />
							(b) Necessary for our legitimate interests
							<br />
							(c) Necessary to comply with a legal obligation
						</td>
						<td>
							(a) Billing, marketing, shipping, hosting, analytics and similar
							service providers
							<br />
							(b) Subsidiaries and affiliates
						</td>
						<td>
							{`We will retain information about you for so long as we have a legal or business purpose for it or a legal requirement to maintain it.  Once we no longer have a legal or business purpose for the information and no legal requirement to maintain the information, we will promptly purge the information.`}
						</td>
					</tr>
					<tr>
						<td>{`Professional or employment-related information`}</td>
						<td>{`(a) Necessary for our legitimate interests`}</td>
						<td>
							(a) Human resources information and similar service providers
							<br />
							(b) Subsidiaries and affiliates
						</td>
						<td>{`We will retain information about you for so long as we have a legal or business purpose for it or a legal requirement to maintain it.  Once we no longer have a legal or business purpose for the information and no legal requirement to maintain the information, we will promptly purge the information.`}</td>
					</tr>
					<tr>
						<td>{`Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99))`}</td>
						<td>
							(a) Performance of a contract
							<br />
							(b) Necessary for our legitimate interests
							<br />
							(c) Necessary to comply with a legal obligation
						</td>
						<td>
							(a) Hosting, analytics and similar service providers
							<br />
							(b) Subsidiaries and affiliates
						</td>
						<td>{`We will retain information about you for so long as we have a legal or business purpose for it or a legal requirement to maintain it.  Once we no longer have a legal or business purpose for the information and no legal requirement to maintain the information, we will promptly purge the information.`}</td>
					</tr>
					<tr>
						<td>{`Sensitive personal information`}</td>
						<td>
							(a) Performance of a contract
							<br />
							(b) Necessary for our legitimate interests
						</td>
						<td>
							(a) Hosting, analytics and similar service providers
							<br />
							(b) Subsidiaries and affiliates
						</td>
						<td>{`We will retain information about you for so long as we have a legal or business purpose for it or a legal requirement to maintain it. Once we no longer have a legal or business purpose for the information and no legal requirement to maintain the information, we will promptly purge the information.`}</td>
					</tr>
				</tbody>
			</table>
			<p>{`The criteria used to determine our retention periods include:`}</p>
			<ul className={styles.list}>
				<li>
					{`The length of time we have an ongoing relationship with you (for example, for
					as long as you are a customer or prospective customer) and the length of time
					thereafter during which we may have a legitimate need to reference your personal
					information to address issues that may arise;`}
				</li>
				<li>
					{`Whether there is a legal obligation to which we are subject (for example,
					certain laws require us to keep records for a certain period of time before
					we can delete them); or`}
				</li>
				<li>
					{`Whether retention is advisable in light of our legal position (such as in regard
					to applicable statutes of limitations, litigation or regulatory investigations).`}
				</li>
			</ul>
			<p>
				<span className={styles.header}>
					Parental and User Rights to Modify Information
				</span>
			</p>
			<p>
				{`A Parent with an individual subscription may access their child’s information at
				any time by signing into their Parent Account and accessing the Manage Account page.
				If you have any questions on how to access your child’s information, please do not
				hesitate to contact us.`}
			</p>
			<p>
				{`A Parent whose child has access to Beast Academy through a School subscription
				must make any requests to access or change their child’s account through the school
				first. As some schools integrate Beast Academy into their lesson plans and
				curricula, we want to ensure our information practices are consistent with school
				needs and do not impede educational activities. The records we maintain on behalf of
				schools are student education records under FERPA. Under FERPA, schools are
				responsible for decisions related to access or modification of these school records.
				Parents and students will continue to have access to the information they provide
				from their accounts. We will work cooperatively and diligently with schools when it
				comes to responding to parent requests.`}
			</p>
			<p>
				<span className={styles.header}>Notice of Consumer Rights</span>
			</p>
			<p>
				{`You may have rights with respect to personal information that has been collected in the last twelve (12) months, including:`}
			</p>
			<ul className={styles.list}>
				<li>
					The right to know what personal information a business has about them
					and what that business does with that information
				</li>
				<li>
					The right to know whether their data is sold or disclosed, and to whom
				</li>
				<li>The right to opt-out (prevent) the sale of their data</li>
				<li>
					The right to opt-out of sharing personal information for cross-context
					or targeted behavioral advertising purposes
				</li>
				<li>The right to correct inaccurate personal information</li>
				<li>
					The right to restrict the processing of sensitive personal information
				</li>
				<li>
					The right to delete their personal information, subject to certain
					exceptions
				</li>
				<li>
					The right to appeal a refusal to take action on a consumer rights
					request
				</li>
			</ul>
			<p>
				{`We will never sell users’ personal information. We do not share personal information for cross-context behavioral advertising purposes. For information on what personal information we collect and how it is used, please refer to the “What Information Does Beast Academy Collect?” and “How Else May Beast Academy Use Collected Information?” sections above.`}
			</p>
			<p>
				{`Only you, or someone legally authorized to act on your behalf, may make a request to know, correct, delete, or appeal related to your personal information. To designate an authorized agent, you must provide a signed, written authorization or a valid power of attorney. You may also make a request on behalf of your child by contacting us through the email associated with the parent account for that child.`}
			</p>
			<p>
				{`To exercise any of these rights, please submit a request by emailing privacy@beastacademy.com with the subject line, "Consumer Rights Request", or mailing your request to the contact address listed in this policy under “Contact Information”. We will need to verify your identity before processing your request, which may require us to request additional personal information from you or require you to log into your account, if you have one. In certain circumstances, we may decline or limit your request, particularly where we are unable to verify your identity or locate your information in our systems, or as permitted by law.`}
			</p>
			<p>
				{`We will not discriminate against you for exercising any of these rights, including denying you goods or services, charging you different prices or rates for goods or services, or providing you a different level or quality of goods or services.`}
			</p>
			<p>
				<span className={styles.header}>Contact Information</span>
			</p>
			<p>
				{`Questions about this policy or with regards to parental rights provided under COPPA may be sent to:`}
			</p>
			<div>
				<div>Beast Academy c/o Art of Problem Solving</div>
				<div>15330 Avenue of Science</div>
				<div>San Diego, CA 92128-3407</div>
				<div className={styles.addressMargin}>(858) 675-4555</div>
				<div>privacy@BeastAcademy.com</div>
			</div>
			<p>
				<span className={styles.header}>
					Disclaimer of Other Sites’ Practices
				</span>
			</p>
			<p>
				{`We are not responsible for the privacy practices or the content of other sites.`}
			</p>
			<p>
				<span className={styles.header}>Effective Date</span>
			</p>
			<p>
				{/* IMPORTANT NOTE FOR CHANGING THE EFFECTIVE DATE HERE:
          You must also update PRIVACY_LAST_UPDATED in shared/Constants.js if all users
          should receive a notification the next time they access BAO alerting them
          to an update to the privacy policy.*/
				`This Privacy Policy is effective 8/31/2023. This Privacy Policy may be updated from
				time to time as necessary.`}
			</p>
		</div>
	);
};

const getTermsContent = function(styles) {
	return (
		<div>
			<h2 className={styles.header}>Beast Academy Terms of Service</h2>
			<p>
				{`AoPS Incorporated (hereafter called “Beast Academy”) operates the Beast Academy websites and services.  This agreement (“Agreement”) is a legal agreement between Beast Academy and you (“you” or “User”) for the use of Beast Academy’s services and website. By using the Beast Academy services and website, you accept these terms. If you do not accept them, do not use the Beast Academy services and website. Beast Academy provides services to you subject to this Agreement. This Agreement and any future versions of this Agreement posted to Beast Academy’s website will be deemed a writing signed by both parties (Beast Academy and the User).`}
			</p>
			<ol className={styles.largeList + " " + styles.list}>
				<li>
					<span className={styles.paragraphStart}>Beast Academy Services:</span>
					{`Beast Academy is dedicated to sharing our love of math and puzzles to inspire the next generation of Math Beasts!  Beast Academy currently provides Users with access to purchase goods like engaging textbooks, workbooks, and online resources.  Online resources include, but are not limited to, online educational activities, curriculum integration for schools, and communication tools on its websites (“Services”). The Agreement applies to these Services and any other services provided on Beast Academy’s websites, unless explicitly stated otherwise. The Services are provided "AS-IS" and Beast Academy assumes no responsibility for the timeliness, deletion, misdelivery, or failure to store any user actions, communications, or personalization settings.  Some Services require the User to pay for their use and may require the User to agree to additional terms.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Registration:</span>
					{`Registration is required for use of certain Services offered on the Beast Academy website. When registration is required, the User agrees to provide all required information accurately. Beast Academy reserves the right to suspend or terminate Services to any User, if Beast Academy in its sole discretion determines that the registration information is not accurate and complete.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Username and Password:</span>
					{`During the registration process, the User will select a Password that gives the User access to their Account. If the User is an Educator or a Parent, then the User may have Student Accounts associated with their Account.  The User may also select Passwords for these Student Accounts. The User is responsible for retaining the Passwords in confidence. The User is responsible for all activities that occur on their Account and the Accounts of their Students. The User agrees to immediately notify Beast Academy of any unauthorized use of the Accounts.`}
					<br />
					<br />
					{`The User may also select a Username for the User and/or for the User's Students to use as onscreen names. Any Username should be a pseudonym and not a real name. The User is responsible for retaining Usernames (both theirs and their Students, if any) in confidence.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						Acceptable Use of Services:
					</span>
					{`User acknowledges and agrees that he or she is fully responsible for all information, data, text, software, music, sound, photographs, graphics, video, messages, or other materials (“Content”) uploaded, posted, e-mailed, transmitted, or otherwise made available by the User via the User’s use of the Beast Academy website and Services.  While Beast Academy makes reasonable efforts not to allow offensive, indecent, or objectionable material on this site, by using the Services, the User may be exposed to Content that is offensive, indecent or objectionable. Under no circumstances will Beast Academy be liable in any way for any Content, including, but not limited to, any errors or omissions in any Content, or for any loss or damage of any kind incurred as a result of the use of any Content posted, e-mailed, transmitted, or otherwise made available via the Services.`}
					<br />
					<br />
					{`The User agrees to the following when using Beast Academy’s Services:`}
					<ul className={styles.list}>
						<li>
							{`Not to impersonate any person or entity, including, but not limited to, a Beast Academy employee, school staff member, guide or guest, or falsely state or otherwise misrepresent your affiliation with any person or entity;`}
						</li>
						<li>
							{`Not to copy, modify, decompile, disassemble, translate into another computer language, create derivative works, access the source code, hack, decrypt, rename files, or otherwise reverse engineer Beast Academy’s websites or intellectual property;`}
						</li>
						<li>
							{`Not to permit use of the Services by anyone other than the User or other authorized Users;`}
						</li>
						<li>
							{`Not to forge headers of postings, e-mails, or otherwise manipulate identifiers in order to disguise the origin of any Content transmitted through the Services;`}
						</li>
						<li>
							{`Not to upload, post, e-mail, transmit, or otherwise make available any Content that is unlawful, harmful, threatening, abusive, harassing, tortuous, defamatory, vulgar, obscene, libelous, invasive of another's privacy in any manner, hateful, or racially, ethnically or otherwise objectionable;`}
						</li>
						<li>
							{`Not to upload, post, e-mail, transmit, or otherwise make available any Content that you do not have a right to make available under any law or under contractual or fiduciary relationships (such as inside information, proprietary and confidential information learned or disclosed as part of employment relationships or under nondisclosure or confidential disclosure agreements);`}
						</li>
						<li>
							{`Not to upload, post, e-mail, transmit, or otherwise make available any Content that can be considered confidential or sensitive in nature;`}
						</li>
						<li>
							{`Not to upload, post, e-mail, transmit, or otherwise make available any Content that infringes any patent, trademark, trade secret, copyright, or any other proprietary and lawful rights of any third party;`}
						</li>
						<li>
							{`Not to upload, post, e-mail, transmit, or otherwise make available any Content that would negatively affect the functioning of the system or would impose an unreasonable or disproportionately large load or burden on this Beast Academy’s systems;`}
						</li>
						<li>
							{`Not to intentionally or unintentionally violate any local, state, national, or international law (including applicable export or re-export control laws and regulations);`}
						</li>
						<li>
							{`Not to bully, “stalk”, or harass another User or any third party through Beast Academy’s website or Services;`}
						</li>
						<li>
							{`Not to collect or store personal data about other users, unless such act is consistent with the use of Beast Academy’s services; and`}
						</li>
						<li>
							{`Not to facilitate, encourage, or otherwise support any User’s acts that violate the terms of this Agreement.`}
						</li>
					</ul>
					<br />
					{`Beast Academy reserves the right to suspend or terminate Services to any User, if Beast Academy, in its sole discretion, determines that a User does not comply with these terms.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Student Privacy:</span>
					{`Users of Beast Academy’s Services may include school officials who integrate Beast Academy’s Services into their curriculums.  Users who upload personally identifiable information from student education records agree that they are responsible for compliance with the Family Educational Rights and Privacy Act (“FERPA”) by ensuring that the disclosure of FERPA-protected information is done with appropriate parent or legal guardian consent or under an exception to the general consent rule, such as the directory information or school official exceptions, as set forth in FERPA. (See 34 CFR 99 et. seq).`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						Interactions with Users:
					</span>
					{`Beast Academy is not responsible for the actions, content, information or data of other third parties, including other Users. Users are responsible for interactions with other parties when using the Services.  Beast Academy reserves the right to settle such disputes (e.g., terminating accounts for violating the Agreement).`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Integration:</span>
					{`This Agreement, together with any other documents referenced herein constitutes the entire agreement between the parties and supersedes all previous agreements, promises, proposals, representations, understandings, and negotiations, whether written or oral, between the parties respecting the subject matter hereof.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						License of User Content:
					</span>
					{`Beast Academy does not claim exclusive ownership of the Content Users submit or make available for inclusion on the Service.  The User hereby grants a non-exclusive, royalty-free, perpetual, irrevocable, fully sub-licensable, world-wide, fully-paid-up license in the Content submitted, transmitted, or created by the User through their use of the Services which allows Beast Academy to use, distribute, reproduce, modify, adapt, publish, translate, publicly perform, and publicly display such Content (in whole or in part) and to incorporate such Content into other works in any format or medium now known or later developed for any purpose allowed by law.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Governing Law:</span>
					{`This Agreement shall be governed by the laws of the State of California without regard to any conflicts of law provisions. If parties cannot resolve disputes informally, User agrees that all disputes arising out of or in connection with this Agreement, or in respect of any legal relationship associated with or derived from this Agreement, (i) any and all disputes between User and Beast Academy shall be fully and finally resolved by binding arbitration following the American Arbitration Association’s rules, (ii) you are waiving any and all rights to a jury trial but all court remedies will be available in arbitration, and (iii) all disputes shall be resolved by a neutral arbitrator who shall issue a written opinion. This provision does not limit Beast Academy’s rights to bring suit in a competent jurisdiction.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Time Limitations:</span>
					{`To the extent allowed by law, the User agrees that any claim or cause of action arising out of this Agreement or related to the Services must be filed within one year after such claim or cause of action arises or forever be barred.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Waiver:</span>
					{`The failure of either party to exercise or enforce any right or provision of the Agreement shall not constitute a waiver of such right or provision.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Enforceability:</span>
					{`If any provision of the Agreement is invalid or contravenes California law, such provision shall be deemed not to be a part of the Agreement and shall not affect the validity or enforceability of its remaining provisions, unless such invalidity or unenforceability would defeat an essential business purpose of the Agreement.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Warranties:</span>
					{`Beast Academy makes no warranty that: (a) the Services will meet your requirements, (b) the Services will be uninterrupted, timely, secure, or error-free, (c) the results that may be obtained from the use of the Services will be accurate or reliable, (d) the quality of any products, Services, information, or other material purchased or obtained by you through the Services will meet your expectations, and (e) any errors in the software will be corrected.`}
					<br />
					<br />
					{`BEAST ACADEMY MAKES NO WARRANTIES OF ANY KIND, INCLUDING BUT NOT LIMITED TO, ANY WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. BEAST ACADEMY SHALL NOT HAVE ANY LIABILITY WHATSOEVER FOR ANY COVER OR SET OFF NOR FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFITS, EVEN IF SUCH PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.`}
					<br />
					<br />
					{`Beast Academy assumes no responsibility for errors or omissions in these materials. Beast Academy makes no commitment to update the information contained herein.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Pricing:</span>
					{`Certain Services are available for a fee, as described on the Beast Academy website and as may be changed from time to time. All fees paid are nonrefundable, subject to any return policies that we in our discretion may adopt from time to time.`}
					<br />
					<br />
					{`Unless otherwise stated, all fees are quoted in U.S. Dollars. You are responsible for paying all administrative fees (such as PayPal fees), governmental fees and applicable taxes associated with the Services and any transactions entered in connection with the Services. If your payment method fails or your account is past due, we may collect fees owed using other collection mechanisms. This includes charging other payment methods on file with us, and retaining collection agencies and legal counsel.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Payment:</span>
					{`Except to the extent we permit purchases with promotional or discount codes prior to the purchase of any Services, you must provide us with a valid credit card number and associated payment information including all of the following: (a) your name as it appears on the card, (b) the billing address, (c) your credit card number, (d) the credit card type, (e) the date of expiration; and (f) the card verification code. By submitting that information to us, you agree that you authorize us to charge your card at our convenience, but within thirty (30) days of credit card authorization. You represent, warrant and agree that you will not use any credit card or other form of payment unless you have all necessary and legally required authorization to do so. We will not be liable if minors or others acting with or without your permission use your credit card to make purchases on the Beast Academy website (and to the extent your minor children make any such purchases, you represent and warrant that they are authorized to do so); however you may report any unauthorized use to us, and we will undertake reasonable measures within our control to help prevent future unauthorized use of your card. Certain fees (as specified on the Beast Academy website) will automatically renew and continue until the associated Services are terminated. You consent to and accept responsibility for all recurring charges to your credit or debit card, by means of ACH authorization (or other payment method, as applicable) without further authorization from you and without further notice except as required by law. You further acknowledge that the amount of the recurring charge may change if the applicable tax rates change or if you are notified that there will be an increase in the applicable fees. In the latter case, you will have the option to opt-out and discontinue service prior to the recurring charge. YOU REPRESENT AND WARRANT THAT (I) THE CREDIT CARD INFORMATION SUPPLIED TO US IS TRUE, CORRECT AND COMPLETE, (II) PAYMENTS MADE YOU WILL BE HONORED BY YOUR CREDIT CARD COMPANY, AND (III) YOU WILL PAY FOR ALL CHARGES INCURRED THROUGH USE OF YOUR LOGIN CREDENTIAL.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Indemnification:</span>
					{`The User agrees to indemnify, hold harmless and defend Beast Academy against any and all third-party claims (including all associated legal fees and disbursements actually incurred) against Beast Academy arising out of a breach by the User of the obligations under this Agreement, or the use or misuse of the Beast Academy’s website or Services by User.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						Risk and Limitation of Liability:
					</span>
					{`Beast Academy shall not be liable for any monetary damages with respect to the User’s use of the Services hereunder, nor shall Beast Academy be liable for any indirect, incidental, consequential, special, punitive or exemplary damages arising out of this Agreement. The total liability of Beast Academy, whether under the express or implied terms of this Agreement, in tort (including negligence or other duty of care) or at common law, for any loss or damage including but not limited to any data loss or corruption, suffered by User or any Users authorized the User, whether direct, indirect or special, or any other similar damage that may arise or does arise from use of the Beast Academy’s website or Services or any breach of this Agreement by Beast Academy, shall in no event exceed the amount paid by the User to Beast Academy for the Services. These limitations of liability shall survive failure of any exclusive remedies provided in the Agreement.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Assignment:</span>
					{`The User will not assign, transfer, delegate any or all of its rights or its duties or obligations under the Agreement without the consent of Beast Academy.  Beast Academy may assign the Agreement to another third-party.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						No Construction Against Drafter:
					</span>
					{`If an ambiguity or question of intent arises with respect to any provision of this Agreement, the Agreement will be construed as if drafted jointly by the parties and no presumption or burden of proof will arise favoring or disfavoring either party by virtue of authorship of any of the provisions of these terms.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Force Majeure:</span>
					{`Either party shall be excused from performance under the Agreement and shall not be liable for any delay in whole or in part, caused by the occurrence of any contingency beyond the reasonable control either of the excused party or its subcontractors or suppliers including, but not limited to, war, sabotage, insurrection, riot or other act of civil disobedience, act of public enemy, failure or delay in transportation, act of any government or any agency or subdivision thereof affecting the terms hereof, accident, fire, explosion, flood, severe weather or other act of God, or shortage of labor or fuel or raw materials.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>
						Limits for Data Storage and Use:
					</span>
					{`Beast Academy may establish general practices and limits concerning use of the Services, including without limitation the maximum number of days that any Content contributed by a User will be retained by the Services, the maximum disk space that will be allotted on Beast Academy servers on a User’s behalf, and the maximum number of times a User may access the Services in a given period of time. Beast Academy has no responsibility or liability for the deletion or failure to store any messages and other communications or other Content maintained or transmitted by the Service. Beast Academy reserves the right to terminate accounts that are inactive for an extended period of time.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>No Sale or Use:</span>
					{`The User agrees not to reproduce, duplicate, copy, sell, resell or exploit for any commercial purposes, any portion of the Services, use of the Services, or access to the Services. This does not apply to the resale of any books purchased by the User.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Termination:</span>
					{`Beast Academy reserves the right to terminate, without prior warning, the access of any User to any Service or Content, for violation of any of the terms in the Agreement, or for any other reason at Beast Academy’s sole discretion. The User may close his/her account and cease use of the Services at any time.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>No Agency:</span>
					{`No agency, partnership, joint venture, or employment is created as a result of this Agreement and you do not have any authority to bind Beast Academy in any respect whatsoever.`}
				</li>
				<li>
					<span className={styles.paragraphStart}>Authority:</span>
					{`If the User is under the age of eighteen (18), the User acknowledges and affirms that his/her legal guardian has reviewed and agreed to the Agreement on the User’s behalf. If a minor User doesn’t get his/her parent or guardian to read and agree to the Agreement, the User doesn’t have permission to use Beast Academy’s website or Services.  If a User is entering into this Agreement on behalf of a school, company, or other entity, the User represents that he/she retains the authority the to bind such entity to the Agreement.`}
				</li>
			</ol>
			<p>
				<span className={styles.subheader}>Copyright Infringement Claims</span>
			</p>
			<p>
				{`If you believe that any material on this website is an infringement of your copyright interests, you must notify us in writing via mail, fax, or email as listed below:`}
			</p>
			<div>
				<div>AoPS Incorporated</div>
				<div>Attn: Designated Copyright Agent</div>
				<div>15330 Avenue of Science</div>
				<div>San Diego, CA 92128-3407</div>
				<div className={styles.addressMargin}>
					Fax: (855) 430-9531. Address fax to the attention of "Designated
					Copyright Agent".
				</div>
				<div>Email: designatedagent@aops.com</div>
			</div>
			<p>
				{`Your notification must contain all of the following elements, in accordance with Title 17 Section 512(c)(3)(A) of U.S. Code:`}
			</p>
			<ol type="i" className={styles.list}>
				<li>
					{`A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.`}
				</li>
				<li>
					{`Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single online site are covered by a single notification, a representative list of such works at that site.`}
				</li>
				<li>
					{`Identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit us to locate the material.`}
				</li>
				<li>
					{`Information reasonably sufficient to permit us to contact the complaining party, such as an address, telephone number, and, if available, an electronic mail address at which the complaining party may be contacted.`}
				</li>
				<li>
					{`A statement that the complaining party has a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law.`}
				</li>
				<li>
					{`A statement that the information in the notification is accurate, and under penalty of perjury, that the complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.`}
				</li>
			</ol>
			{`Upon receipt of a bona fide notification of copyright infringement that contains all of the above elements, Beast Academy will remove the allegedly infringing material and notify the User who provided the material. Users who repeatedly post Content that infringe on other entities' copyrights are subject to having their Beast Academy access terminated.`}
		</div>
	);
};

module.exports = {
	getPrivacyContent,
	getTermsContent,
};
